import PropTypes from 'prop-types';
import cn from 'classnames';

import example from './Example.module.scss';

export const Example = ({ propVal, schemaType, type, property = 'Example' }) => {
  return (
    <div className={example.example__property}>
      <div
        className={cn(example.example__hardcode, {
          [example.example__hardcode__mini]: schemaType === 'mini',
        })}
      >
        {property}:
      </div>
      <div
        className={cn(example.example__text, {
          [example.example__text__mini]: schemaType === 'mini',
        })}
      >
        {(type === 'string' && `${propVal}`) || (type === 'boolean' && `${propVal}`) || propVal}
      </div>
    </div>
  );
};
Example.propTypes = {
  propVal: PropTypes.any,
  schemaType: PropTypes.string,
  type: PropTypes.string,
};

export default Example;
